import { ReactNode } from "react";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useQueryClient,
  useMutation,
  useIsRestoring,
  onlineManager
} from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export function createTanStackQueryReact(queryClient: QueryClient) {
  function Provider({ children }: { children: ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        {children}
      </QueryClientProvider>
    );
  }

  return {
    Provider,
    useQueryClient,
    useQuery,
    useMutation,
    useIsRestoring,
    onlineManager
  };
}
